import { useLazyQuery } from '@apollo/client/react';
import { useSetAtom } from 'jotai';
import { useCallback, useEffect } from 'react';

import { GetIncompleteTaskCountDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';
import { useSubscriptions } from '~/hooks/use-subscriptions';
import { receptionPageInfoState } from '~/state/reception/atoms';

export const useFetchIncompleteTaskCount = () => {
  const setState = useSetAtom(receptionPageInfoState);
  const [getIncompleteTaskCount, { data, loading }] = useLazyQuery(GetIncompleteTaskCountDocument, {
    fetchPolicy: 'network-only',
  });
  const [event] = useSubscriptions('Appointment', ['created', 'updated', 'deleted']);
  const [outpatientQuestionnaireEvent] = useSubscriptions('OutpatientQuestionnaireEntry', [
    'created',
    'updated',
    'deleted',
  ]);
  const [clearCheckinEntryEvent] = useSubscriptions('CheckinEntry', [
    'created',
    'updated',
    'deleted',
  ]);

  const organization = data && getMe(data)?.organization;
  const incompleteAppointmentCount = organization?.incompleteAppointmentCount || 0;
  const incompleteDraftAppointmentCount = organization?.incompleteDraftAppointmentCount || 0;
  const incompleteCheckinEntryCount = organization?.incompleteCheckinEntryCount || 0;
  const incompleteOutpatientQuestionnaireEntryCount =
    organization?.incompleteOutpatientQuestionnaireEntryCount || 0;
  const totalCount =
    incompleteAppointmentCount +
    incompleteDraftAppointmentCount +
    incompleteCheckinEntryCount +
    incompleteOutpatientQuestionnaireEntryCount;
  const handleShow = useCallback(() => {
    setState((state) => ({
      ...state,
      page: 1,
      date: null,
      statuses: ['status1', 'status2', 'status3', 'status4', 'status7'],
      patientName: null,
    }));
  }, [setState]);

  // マウント時に件数取得
  useEffect(() => {
    getIncompleteTaskCount();
  }, [getIncompleteTaskCount]);

  useEffect(() => {
    if (event || outpatientQuestionnaireEvent || clearCheckinEntryEvent) {
      getIncompleteTaskCount();
    }
  }, [event, outpatientQuestionnaireEvent, clearCheckinEntryEvent, getIncompleteTaskCount]);

  return {
    totalCount,
    loading,
    handleShow,
  };
};
